module.exports = __webpack_public_path__ + "img/rights-title.2bf67d4a.png";